import { Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { AuthAppService } from 'avn/services/auth-app/auth-app.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ProfileGuard {
  // Inject AuthAppService to access user data and Router for navigation
  constructor(
    private auth: AuthAppService,
    private router: Router
  ) {}

  // Determines whether the route can be activated based on user authentication
  canActivate(): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (this.auth.getSavedUser()?.email) {
      return true;
    }
    this.router.navigate(['']);
    return false;
  }
}
